import { getDefaultNormalizer } from "@testing-library/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from 'react-select'
import { apiSendGenericSupportEmail } from "../../services/EmailService";
import Button from "../common/Button";
import CheckBox from "../common/CheckBox";
import ComboBox from "../common/ComboBox";
import { DatePicker } from "../common/DatePicker";
import { TextArea } from "../common/TextArea";
import { TextBox } from "../common/TextBox";
import { TextBoxEmail } from "../common/TextBoxEmail";
import { SupportQueryType } from "./constants";

//require("./UserRoles.css");

interface Props {
    onRequestSent?: any;
    queryType: SupportQueryType;
}

const translationPrefix = 'Support';

const GenericSupportQuery = (props: Props) => {
    const { t } = useTranslation(undefined, { keyPrefix: translationPrefix });
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        text: ''
    });

    const handleSendRequest = () => {
        apiSendGenericSupportEmail(formData.text, props.queryType).then((response) => {
            props.onRequestSent(true);
            setFormData({ text: '' })
        }).catch((err: any) => {
            props.onRequestSent(false, err);
        });
    }

    return (
        <>
            <TextArea
                id={'genericQuery'}
                label={t('Question')}
                placeholder={t('QuestionPlaceHolder')}
                rows={10}
                dataField="text"
                formData={formData}
                setStateMethod={setFormData}
                value={formData.text}
                customColClassForLabel={'col-sm-2'}
                customColClassForValue={'col-sm-4'}
            />
            <Button
                text={t('Submit')}
                onClick={handleSendRequest}
                iconClass={'unset'}
            />
        </>
    );
}

export default GenericSupportQuery;